import * as angular from "angular";

angular
  .module('bringoz.admin.service-analysis')
  .constant('ServiceAnalysis_PN', {
    database: 'serviceAnalysisGenerateTask',
    isBranchEntity: false
  });
